// extracted by mini-css-extract-plugin
export default {"container":"nK-z","dimension":"oK-z","dimensionLabels":"pK-z"};